import Api from '@/services/Api'
import {mapState} from 'vuex'
import store from '@/store/store'


export default {
	// index (search, testType) {
	// 	return Api().get('clients', {
	// 		params: {
	// 			search: search,
	// 			testType: store.state.testType
	// 		}
	// 	})
	// },
	index (search, testType) {
		return Api().get('clients', {
			params: {
				search: search,
				testType: store.state.testType
			}
		})
	},
	show (clientId) {
		return Api().get(`clients/${clientId}`)
	},
	showPDF (clientId) {
		return Api().get(`clients/pdf/${clientId}`)
	}	
}



// WEBPACK FOOTER //
// ./src/services/ClientsService.js